export default function ObservationBox({ title, children, className = "", titleClassName = "", boxClassName = "" }) {
    return (
        <div className={`relative w-full ${className}`}>
            <div className={`absolute -top-3 left-3 bg-white px-1 text-sm text-[#161616] whitespace-pre-wrap ${titleClassName}`}>
                {title}
            </div>
            <div className={`min-h-[40px] h-full w-full rounded-[5px] border border-[#e0e0e0] text-[#161616] p-2 whitespace-pre-wrap break-words overflow-visible text-left align-top ${boxClassName}`}>
                {children || ""}
            </div>
        </div>
    )
}